<template>
  <b-container>
    <b-row>
      <b-col>
        <validation-observer
          ref="formRef"
          v-slot="{ invalid }"
          class="form form-sm mx-auto"
        >
          <b-form @submit.prevent="handleSubmit">
            <FormHeader bookmarkable>Forgot Password</FormHeader>

            <base-input
              v-model="formData.email"
              rules="required|email"
              name="Email Address"
              label="Email Address"
              payload-name="email"
              @input="resetMessages"
              @focus="resetMessages"
            >
              <template v-if="!!successMessage" #success>
                <b-alert
                  variant="primary"
                  class="py-1 px-3 mt-2 text-center"
                  show
                  >{{ successMessage }}</b-alert
                >
              </template>

              <template v-if="!!errorMessage" #error>
                <b-alert
                  variant="danger"
                  class="py-1 px-3 mt-2 text-center"
                  show
                  >{{ errorMessage }}</b-alert
                >
              </template>
            </base-input>

            <router-link
              :to="{ name: 'Login' }"
              class="text-dark text-right d-block small font-weight-bold"
              >Login here</router-link
            >

            <base-button
              :disabled="invalid"
              :loading="formProcessing"
              type="primary"
              native-type="submit"
              size="lg"
              class="mt-4"
              block
              >Submit</base-button
            >
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { defineComponent, reactive, ref } from '@vue/composition-api'
import { useRouter } from 'vue2-helpers/vue-router'

import AuthenticationService from '@services/authentication'

import FormHeader from '@components/FormHeader'

export default defineComponent({
  name: 'ForgotPassword',
  title: 'Forgot Password',
  components: {
    FormHeader
  },
  setup() {
    const router = useRouter()

    const formRef = ref(null)
    const formProcessing = ref(false)

    const successMessage = ref('')
    const errorMessage = ref('')

    const resetMessages = () => {
      successMessage.value = ''
      errorMessage.value = ''
    }

    const formData = reactive({})

    const handleSubmit = () => {
      resetMessages()

      formProcessing.value = true

      AuthenticationService.resetPassword(formData.email)
        .then((res) => {
          const { data } = JSON.parse(res.data) || {}
          const { detail } = data || {}

          formRef.value.reset()

          successMessage.value = detail

          formProcessing.value = false

          router.push({
            name: 'Login'
          })
        })
        .catch((error) => {
          const { data } = JSON.parse(error.response.data) || {}
          const { token, email } = data || {}

          if (!!token) errorMessage.value = 'Invalid token.'
          else if (!!email) successMessage.value = email.error

          formProcessing.value = false
          formData.email = null

          formRef.value.reset()
        })
    }

    return {
      formRef,
      formProcessing,
      formData,

      successMessage,
      errorMessage,
      resetMessages,

      handleSubmit
    }
  }
})
</script>
